// import "services/sentry/instrument";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "styles/index.css";
import { initI18n } from "shared/services/localization/i18n.ts";

const rootElement = document.getElementById("root") as HTMLElement;

(async function main() {
  // Wait for i18next + translations to be ready
  await initI18n();

  ReactDOM.createRoot(rootElement).render(<App />);
})();